$(document).ready(function () {
  $('.pick-choose').click(function (e) {
    var vid = $(this).attr('variant_id');
    $("#vid").val(vid);
  });

  document.querySelectorAll('.pick-choose').forEach(item => {
    item.addEventListener('click', function() {
      let radioButton = item.querySelector('input[type="radio"]');
      radioButton.checked = true; // Set radio button to checked
    });
  });
});

let cartData = null;
  
// Plan Variable Declaration
const monthly_plan = 44283189100765;
const six_month_plan = 44283209777373;
const one_year_plan = 43813033836765;
const two_year_plan = 43879658946781;

// Activation Fee
const activation_fee_variant = 43795278954717;

$(document).ready(async function () {
  cartData = await fetchCart();

  if(!cartData) {
    window.location = '/pages/upgrade-started';
    return;
  }

  cartBuyerIdentityUpdate();

  const existingCartPlans = (cartData?.lines?.edges ?? []).filter((obj) => {
    return [
      `gid://shopify/ProductVariant/${monthly_plan}`,
      `gid://shopify/ProductVariant/${six_month_plan}`,
      `gid://shopify/ProductVariant/${one_year_plan}`,
      `gid://shopify/ProductVariant/${two_year_plan}`,
    ].includes(obj.node.merchandise.id);
  });

  if (existingCartPlans.length > 0) {
    for (const cp of existingCartPlans) {
      const variantId = cp?.node?.merchandise?.id?.replace('gid://shopify/ProductVariant/', '');
      if (variantId) {
        $("#vid").val(variantId);
        $('.pick-inn')?.find(`.pick-choose[variant_id="${ variantId }"]`)?.find('input[type="radio"]')?.prop('checked', true);
      }
    }
  } else {
    $("#vid").val(two_year_plan);
    $('.pick-inn')?.find(`.pick-choose[variant_id="${ two_year_plan }"]`)?.find('input[type="radio"]')?.prop('checked', true);
  }
});

async function reChargeProcessCartwithoutupsell() {
  $("#continue_btn").prop('disabled', true);

  cartData = await fetchCart();
  if(!cartData) {
    notify('error', "Cart Retrieval Failed", "We encountered an issue while retrieving your data. Please try starting from the first step.")
    $("#continue_btn").prop('disabled', false);
    return;
  }

  var v_id = $("#vid").val();
  
  if (!v_id) {
    notify('error', "Failed to proceed", "Please select a plan to continue")
    $("#continue_btn").prop('disabled', false);
    return;
  }
  
  if (v_id == monthly_plan) {
    var selling_plan = 6317867229;
  } else if (v_id == six_month_plan) {
    var selling_plan = 5220270301;
  } else if (v_id == one_year_plan) {
    var selling_plan = 5220401373;
  } else if (v_id == two_year_plan) {
    var selling_plan = 6517260509;
  }

  const existingCartItems = (cartData?.lines?.edges ?? []).filter((obj) => {
    return [
      `gid://shopify/ProductVariant/${monthly_plan}`,
      `gid://shopify/ProductVariant/${six_month_plan}`,
      `gid://shopify/ProductVariant/${one_year_plan}`,
      `gid://shopify/ProductVariant/${two_year_plan}`,
      `gid://shopify/ProductVariant/${activation_fee_variant}`,
    ].includes(obj.node.merchandise.id);
  });

  if(existingCartItems.length > 0) {
    const itemsToRemove = [];        
    
    for (const cItem of existingCartItems) {
      itemsToRemove.push(cItem?.node?.id);
    }

    if(!await removeCartItem(itemsToRemove)) {
      $("#continue_btn").prop('disabled', false);
      return;
    }
  }

  if (await addCartItem([
    {
      variant_id: v_id,
      selling_plan_id: selling_plan,
      quantity: 1,
    },
    {
      variant_id: activation_fee_variant, // Activation Fee
      quantity: 1
    }
  ])) {
    window.location.href = `/pages/upgrade-cosmo-care`;
    setTimeout(() => {
      $("#continue_btn").prop('disabled', false);
    }, 3000);
  } else {
    $("#continue_btn").prop('disabled', false);
  }
}

function addCartItem(lineItem) {
  return new Promise((resolve, reject) => {
    const cartId = localStorage.getItem('shopify-gql-cartid');
    if (cartId) {
      jQuery.ajax({
        url: `${ACTIVATIONAPI_BASEURL}/shopify/cart/lines/add`,
        type: "POST",
        contentType: "application/json",
        dataType: "JSON",
        processData: false,
        data: JSON.stringify({
          cart_id: cartId,
          items: Array.isArray(lineItem) ? lineItem : [lineItem],
          operation: "plan-select"
        }),
      }).done(function (response) {
        return resolve(true);
      }).fail(function (error) {
        showErrorMessage(error, "Failed to Add to Cart");
        return resolve(false);
      });
    } else {
      notify('error', "Failed to Add to Cart", "We encountered an issue while retrieving your data. Please try starting from the first step.")
      return resolve(false);
    }
  })
}

function removeCartItem(lineItemId) {
  return new Promise((resolve, reject) => {
    const cartId = localStorage.getItem('shopify-gql-cartid');
    if (cartId) {
      jQuery.ajax({
        url: `${ACTIVATIONAPI_BASEURL}/shopify/cart/lines/remove`,
        type: "POST",
        contentType: "application/json",
        dataType: "JSON",
        processData: false,
        data: JSON.stringify({
          cart_id: cartId,
          line_ids: Array.isArray(lineItemId) ? lineItemId : [lineItemId],
        }),
      }).done(function (response) {
        return resolve(true);
      }).fail(function (error) {
        showErrorMessage(error, "Oops! Removal Failed");
        return resolve(false);
      });
    } else {
      notify('error', "Oops! Removal Failed", "We encountered an issue while retrieving your data. Please try starting from the first step.")
      return resolve(false);
    }
  })
}

function cartBuyerIdentityUpdate() {
  return new Promise((resolve, reject) => {
    const cartId = localStorage.getItem('shopify-gql-cartid');
    if (cartId) {
      jQuery.ajax({
        url: `${ACTIVATIONAPI_BASEURL}/shopify/cart/buyer-identity/update`,
        type: "POST",
        contentType: "application/json",
        dataType: "JSON",
        processData: false,
        data: JSON.stringify({
          cart_id: cartId,
          buyer_email: cartData?.buyerIdentity?.email ?? null,
          country_code: ["CA"].includes(window.shopLocaleData?.countryIsoCode) ? window.shopLocaleData?.countryIsoCode : "US",
        }),
      }).done(function (response) {
        return resolve(true);
      }).fail(function (error) {
        showErrorMessage(error, "Identity Update Failed");
        return resolve(false);
      });
    } else {
      notify('error', "Identity Update Failed", "We encountered an issue while retrieving your data. Please try starting from the first step.")
      return resolve(false);
    }
  })
}

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});